export type VoskDictationModelId = 'small';

export interface VoskDictationModelOption {
  id: VoskDictationModelId;
  label: string;
  description: string;
  /** Path or URL to a browser-compatible .tar.gz model archive. */
  url: string;
  sizeMb: number;
}

export interface VoskDictationConfig {
  defaultModelId: VoskDictationModelId;
  models: VoskDictationModelOption[];
}

/** Pre-packaged model used by the vosk-browser demo (known-good tar layout). */
const VOSK_SMALL_MODEL_CDN =
  'https://ccoreilly.github.io/vosk-browser/models/vosk-model-small-en-us-0.15.tar.gz';

export const VOSK_DICTATION_MODELS: VoskDictationConfig = {
  defaultModelId: 'small',
  models: [
    {
      id: 'small',
      label: 'English',
      description: 'vosk-model-small-en-us-0.15',
      url: VOSK_SMALL_MODEL_CDN,
      sizeMb: 40
    }
  ]
};

export const VOSK_RECOGNIZER_PROCESSOR_URL = '/assets/vosk/recognizer-processor.js';
